import { publicRuntimeConfig } from './publicRuntimeConfig';

export const buildCanonicalUrl = (asPath: string) => {
  const { base } = publicRuntimeConfig;
  const [rawDeliveryKey = ''] = asPath?.split('?') ?? [];
  const deliveryKey = rawDeliveryKey.replace(/^\/+/, '');
  return deliveryKey ? `${base}/${deliveryKey}` : base;
};
